import { themeConfigurationValuesTypes } from "../../types";

export const defaultThemeValues:themeConfigurationValuesTypes = {
    "themeColor":{
      "name": "themeColor",
      "type": "string",
      "value": "",
      "docUrl": "",
      "description": "theme color",
      "possibleVals": [
        "string"
      ]
    },
    "themeBackGroundColor":{
      "name": "themeBackGroundColor",
      "type": "string",
      "value": "",
      "docUrl": "",
      "description": "theme color",
      "possibleVals": [
        "string"
      ]
    },
    "themeDisabledButtonColor":{
      "name": "themeDisabledButtonColor",
      "type": "string",
      "value": "",
      "docUrl": "",
      "description": "theme color",
      "possibleVals": [
        "string"
      ]
    },
    "activeLanguageColor":{
      "name": "activeLanguageColor",
      "type": "string",
      "value": "",
      "docUrl": "",
      "description": "theme color",
      "possibleVals": [
        "string"
      ]
    }
}